import { RedistributionErrorCodeKeys } from '~/purchase/types';
import { RedistributionErrorCodes } from '~/common/helpers';
import { TranslationKeys } from '~/common/types';

const i18nProxyHandler = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(target: object, propertyKey: PropertyKey, receiver?: any) {
    const value = Reflect.get(target, propertyKey, receiver);
    if (value === undefined) return propertyKey;
    return value;
  },
};
export const RedistributionErrorCodesLookup = new Proxy<
  Record<RedistributionErrorCodeKeys, keyof TranslationKeys>
>(
  {
    [RedistributionErrorCodes.ERR_ACTIVE_PRICING_POLICY_EXISTS]:
      'app.quote.pricing_policy.errors.err_active_pricing_policy_exists',
  },
  i18nProxyHandler,
);
